<template>
    <el-dialog title="导入" width="640px" :model-value="modelValue" @close="closed" :close-on-click-modal="false">
        <el-form ref="formRef" :model="formData" label-width="120px" style="max-width: 540px" :rules="formRules">
            <el-form-item label="选择文件" prop="excel_file_name">
                <el-input placeholder="请选择上传文件" v-model="formData.excel_file_name" disabled>
                    <template #append>
                        <el-upload
                            ref="upload"
                            action="#"
                            :limit="1"
                            :on-exceed="handleExceed"
                            :auto-upload="false"
                            :show-file-list="false"
                            :http-request="httpRequest"
                            :on-change="beforeUpload"
                        >
                            <template #trigger>
                                <el-button type="primary">选择文件</el-button>
                            </template>
                        </el-upload>
                    </template>
                </el-input>
            </el-form-item>
            <el-form-item>
                <p>支持.xls,.xlsx格式的文件</p>
            </el-form-item>
            <el-form-item>
                <span style="color: blue; cursor: pointer" @click="downloadTem">模板下载</span>
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closed">取消</el-button>
                <el-button type="primary" :loading="submitLoading" @click="onConfirm">确定</el-button>
            </span>
        </template>
        <div class="downLoadTemplateMask" v-if="downloadTemplateMaskVisible">
            导入模板正在生成中，可能需要5-10分钟，请耐心等待。
        </div>
    </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps, ref } from 'vue'
import { downloadTemplate, importsRoom } from '@/api/sys.js'
import { ElMessage } from 'element-plus'

const emits = defineEmits(['update:modelValue', 'updateForm'])
const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    menuCode: {
        type: String,
        required: true
    },
    paramsData: {
        type: Object,
        required: false,
        default: () => {
            return {}
        }
    }
})
// 表单源
const formData = ref({
    excel_file_name: null
})

const formRules = ref({
    excel_file_name: [
        {
            required: true,
            trigger: 'blur',
            message: '请选择上传文件'
        }
    ]
})

const submitLoading = ref(false)
const formRef = ref(null)
/**
 * 关闭
 */
const closed = () => {
    emits('update:modelValue', false)
    formRef.value.resetFields()
}
// 点击下载模板时启用遮罩层
const downloadTemplateMaskVisible = ref(false)
const httpRequest = () => {}
const downloadTem = async () => {
    if (props.menuCode === 'event/linkage') {
        ElMessage.success('正在下载导入模板，该过程可能需要5分钟，请在当前页面等待...')
        downloadTemplateMaskVisible.value = true
    }
    try {
        const data = await downloadTemplate(props.menuCode, props.paramsData)
        window.open(data.data)
        downloadTemplateMaskVisible.value = false
    } catch (e) {}
}

const onConfirm = () => {
    formRef.value.validate(async (valid) => {
        if (valid) {
            const formData = new FormData()
            formData.append('excel_file', excelFile.value)
            importsRoom(props.menuCode, formData, props.paramsData).then((data) => {
                ElMessage.success('导入成功')
                emits('updateForm')
                closed()
            })
        }
    })
}

const excelFile = ref('')
const upload = ref(null)
const handleExceed = (files) => {
    upload.value.clearFiles()
    excelFile.value = files[0]
    formData.value.excel_file_name = files[0].name
}
const beforeUpload = (file) => {
    excelFile.value = file.raw
    formData.value.excel_file_name = file.name
}
</script>

<style lang="scss" scoped>
:deep(.el-input-group__append, .el-input-group__prepend) {
    background-color: #409eef;
    color: #ffffff;
}
.downLoadTemplateMask {
    width: 100vw;
    height: 100vh;
    z-index: 999999;
    background: rgba($color: #333, $alpha: 0.7);
    position: fixed;
    left: 0;
    top: 0;
    line-height: 100vh;
    text-align: center;
    font-size: 20px;
    font-weight: 700;
    color: #de9324;
}
</style>
